// extracted by mini-css-extract-plugin
export default {"title":"BorderBox_title__v2GCK"};